import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from './config';

export default function Theme({ children }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
